"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createVueComponent = _interopRequireDefault(require("../createVueComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Volume1 = (0, _createVueComponent.default)('Volume1Icon', [['polygon', {
  points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5'
}], ['path', {
  d: 'M15.54 8.46a5 5 0 010 7.07'
}]]);
var _default = Volume1;
exports.default = _default;